import React, { useEffect } from "react";
import Page from "components/Page";
import Table from "components/table";
import { withTranslation } from "react-i18next";
import Empty from "components/Empty";
import moment from "moment";
import "../OfficePolicyManagement.scss";
import styles from "../OfficePolicyManagement.module.scss";
import { useGlobalLogsHistoryListing } from "repositories/office-policy-management-repository";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import { useGlobalLogsHistoryExport } from "../../../../repositories/office-policy-management-repository";
import toast from "react-hot-toast";
import { b64toBlob, handleError, formatLocalDateTime } from "../../../../utils";
import FileSaver from "file-saver";
import { getLocalTimeZoneCode } from "accountOwner/pages/AddEvent/addEvents.functions";
const actionValues = {
  1: { label: "Created", btnColor: "blue" },
  2: { label: "Edited", btnColor: "blue" },
  3: { label: "Deleted", btnColor: "red" },
  4: { label: "Archived", btnColor: "grey" },
  5: { label: "Version Added", btnColor: "blue" },
  Created: { label: "Created", btnColor: "blue" },
  Edited: { label: "Edited", btnColor: "blue" },
  Deleted: { label: "Deleted", btnColor: "red" },
  Archived: { label: "Archived", btnColor: "grey" },
  VersionAdded: { label: "Version Added", btnColor: "blue" },
};
function PolicyLogsListing({ history, location, t }) {
  const { timeZoneId } = getLocalTimeZoneCode();
  console.log("localTimezone-d id", timeZoneId);

  const { effectiveOwnerId, getIdToCheckOwnerChange } = useAccountOwnerCommon();
  const {
    isLoading: isGlobalLogsLoading,
    isFetching: isGlobalLogsFetching,
    data: isGlobalLogsData,
  } = useGlobalLogsHistoryListing(
    { ownerId: effectiveOwnerId },
    { enabled: !!effectiveOwnerId },
  );
  const secureFileDownload = (
    base64Content,
    fileName,
    contentType = "application/octet-stream",
    t,
  ) => {
    try {
      // Validate inputs
      if (!base64Content || !fileName) {
        throw new Error(t("aiAssistant.invalidFile"));
      }

      // Sanitize filename to prevent path traversal attacks
      const sanitizedFileName = fileName.replace(/[^a-zA-Z0-9._-]/g, "_");

      // Use existing safe utility function
      const blob = b64toBlob(base64Content, contentType);

      // Create a safe download using FileSaver
      FileSaver.saveAs(blob, sanitizedFileName);

      return true;
    } catch (error) {
      handleError(t("aiAssistant.fileDownloadError"));
      return false;
    }
  };
  const exportPolicyLogs = useGlobalLogsHistoryExport(
    { ownerId: effectiveOwnerId, timeZoneId: timeZoneId },
    {
      enabled: !!effectiveOwnerId,
      onSuccess: (e) => {
        if (e.data.file_Url) {
          const success = secureFileDownload(
            e.data.file_Url,
            `policy-logs-${moment().toISOString()}.xlsx`,
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            t,
          );
          if (success) {
            toast.success("Policy logs exported successfully");
          } else {
            toast.error("Failed to export policy logs");
          }
        }
      },
      onError: (error) => {
        toast.error(error.message);
      },
    },
  );
  const goBack = () => history.goBack();
  useEffect(() => {
    if (getIdToCheckOwnerChange()) {
      history.goBack();
    }
  }, [effectiveOwnerId]);
  if (
    !isGlobalLogsLoading &&
    isGlobalLogsData &&
    isGlobalLogsData.data.length === 0
  ) {
    return (
      <Page titleKey={"Policy Logs"} onBack={goBack}>
        <Empty
          Message={t("officePolicyManagement.noHistoryLogsForSelection")}
        />
      </Page>
    );
  }
  const columns = [
    {
      text: "Action",
      dataField: "applicableFrom",
      attrs: { datatitle: "Action" },
      formatter: (cellContent, row) => {
        if (row?.action) {
          // styles[red , green , blue]
          const action = actionValues[row.action];
          return (
            <span
              className={styles["action-btn"] + " " + styles[action.btnColor]}
            >
              {action.label}
            </span>
          );
        }
        return <div className="text-placeholder-150 shimmer-animation"></div>;
      },
    },
    {
      text: "Policy Name",
      attrs: { datatitle: "Policy Name" },
      dataField: "hourlyRate",
      formatter: (cellContent, row) => {
        if (row?.policyFolderName)
          return (
            <span className={styles["text-color-size"]}>
              {row.policyFolderName || "--"}
            </span>
          );
        return <div className="text-placeholder-100 shimmer-animation"></div>;
      },
    },
    {
      text: "Action Taken On",
      attrs: { datatitle: "Action Taken On" },
      dataField: "hourlyRate",
      formatter: (cellContent, row) => {
        if (row?.createdAt)
          return (
            <span className={styles["text-color-size"]}>
              {formatLocalDateTime(row?.createdAt, "ddd, MMM DD, YYYY") || "--"}
            </span>
          );
        return <div className="text-placeholder-100 shimmer-animation"></div>;
      },
    },
    {
      text: "Performed By",
      attrs: { datatitle: "Performed By" },
      dataField: "hourlyRate",
      formatter: (cellContent, row) => {
        if (row?.createdBy)
          return (
            <span className={styles["text-color-size"]}>
              {row.createdBy?.name}
            </span>
          );
        return <div className="text-placeholder-100 shimmer-animation"></div>;
      },
    },
  ];

  let rows = [];
  if (isGlobalLogsLoading || isGlobalLogsFetching) {
    rows = new Array(10).fill({});
  } else {
    rows = isGlobalLogsData?.data || [];
  }

  return (
    <Page
      titleKey={t("officePolicyManagement.policyLogs")}
      onBack={goBack}
      actionButton={
        <button
          className={styles["export-btn"]}
          disabled={exportPolicyLogs.isLoading || exportPolicyLogs.isFetching}
          onClick={() => exportPolicyLogs.mutate()}
        >
          {exportPolicyLogs.isLoading || exportPolicyLogs.isFetching
            ? "Exporting..."
            : "Export"}
        </button>
      }
    >
      <div className={` ${styles["policy-history-table-box"]}`}>
        <Table columns={columns} data={rows} keyField="id" disablePagination />

        {/* {!isLoading && totalItems === 0 && (
          <Empty Message={t("superAdmin.noSpecialtyOrServiceFound")} />
        )} */}
      </div>
    </Page>
  );
}

export default withTranslation()(PolicyLogsListing);
